import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Checkbox as UICheckbox } from '@material-ui/core'

function Checkbox({ label, checked, onChange }) {
  return (
    <FormControlLabel
      control={
        <UICheckbox
          checked={checked}
          onChange={onChange}
          color='primary'        
        />
      }
      label={label}
    />
  )
}

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

Checkbox.defaultProps = {
  label: '',
  checked: false,
  onChange: () => true
}

export default Checkbox